import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GradFlow } from "gradflow";

import Footer from "../components/Footer";
import HeroBubbles from "../components/HeroBubbles";
import RvrRoadmap from "../components/RvrRoadmap";
import ParentBrand from "../components/ParentBrand";
import { HERO_GRADFLOW_CONFIG } from "../utils/heroGradient";

// Canonical copy for the three stages. src/pages/Home.jsx summarises these in
// its "How BLEEP works" section and points here, so edit them here first.
const About = ({ domain }) => {
  return (
    <div className="bleep-light bl-page">
      <Helmet>
        <title>About | BLEEP</title>
        <meta
          name="description"
          content="BLEEP empowers consumers to report suspected counterfeit or substandard products and works with brands and regulators to verify and take remedial action."
        />
      </Helmet>

      {/* ---------------------------------------------------------------- Hero */}
      <section className="bl-hero about-hero">
        <GradFlow className="bl-hero__gradflow" config={HERO_GRADFLOW_CONFIG} />
        {/* Sibling of the shell: .bl-shell caps at 1200px and would strangle
            the rails on wide screens. */}
        <HeroBubbles />
        <div className="bl-shell">
          <div className="bl-hero__copy">
            <h1 className="about-hero__title">
              Counterfeits hurt people and brands.
            </h1>
            <p className="about-hero__lead">
              BLEEP puts consumers, brands and regulators on the same thread, so
              a suspect product is found fast and acted on.
            </p>

            {/* Takes over from the side rails below 1280px, where the gutters
                have collapsed. CSS shows exactly one of the two. */}
            <HeroBubbles variant="inline" />
          </div>
        </div>
      </section>

      {/* ------------------------------------------------------------- Mission */}
      <section className="bl-section bl-section--dark">
        <div className="bl-shell about-mission">
          <div className="about-mission__copy">
            <div className="bl-section-head">
              <div>
                <h2 className="bl-section-title">Our mission</h2>
                <p className="bl-section-lead">
                  Empowering consumers to fight counterfeits
                </p>
              </div>
            </div>
            <p className="about-prose">
              BLEEP is a consumer protection platform that makes it simple to
              report a suspected counterfeit or substandard product. Reports are
              routed to the partners who can do something about them, so
              verification and corrective action happen quickly.
            </p>
            <p className="about-prose">
              The result is a safer marketplace, stronger brand trust, and real
              transparency for everyone buying and selling in it.
            </p>
          </div>

          {/* Second in the DOM, so the single-column layout stacks it under the
              copy without any ordering rules. */}
          <figure className="about-mission__media">
            <img
              src="/images/fakes_cost_more.gif"
              alt="Fakes cost more"
              className="about-mission__gif"
              width="800"
              height="800"
              loading="lazy"
            />
          </figure>
        </div>
      </section>

      {/* ----------------------------------------------------------------- RVR */}
      <section className="bl-section bl-section--surface">
        <div className="bl-shell">
          <div className="bl-section-head">
            <div>
              <h2 className="bl-section-title">How BLEEP works</h2>
              <p className="bl-section-lead">
                RVR: Report, Verify and Remedial Action
              </p>
            </div>
          </div>
          <RvrRoadmap />
        </div>
      </section>

      <ParentBrand />

      {/* ------------------------------------------------------------ Closing */}
      {/* Page colour. RVR and the credit above it are already two surfaces in a
          row; a third would make the bottom half of the page one white slab. */}
      <section className="bl-section">
        <div className="bl-shell about-cta">
          <h2 className="bl-section-title">Spotted something suspicious?</h2>
          <p className="bl-section-lead">
            Filing a report takes under a minute.
          </p>
          <Link to="/report" className="home-seeall">
            Report a product
            <span className="home-seeall__arrow">
              <i className="fas fa-arrow-right" aria-hidden="true" />
            </span>
          </Link>
        </div>
      </section>

      <Footer domain={domain} />
    </div>
  );
};

export default About;
